
import React from 'react';
import AdsPageLayout from '../Components/AdsPage/AdsPageLayout';
import { adsPageConfigs, commonComparisonData, commonAdvantages } from '../Components/AdsPage/adsData';
import schemaPPND from "../Assets/Images/SchemaFacturation/SchemaPpnd.png";

export default function PpndPageAds() {
  const config = adsPageConfigs.ppnd;
  
  // Données spécifiques pour cette page
  const comparisonData = [
    {
      label: "Vos cours sont déclarés",
      system: 0,
      aici: 1,
    },
    {
      label: "Montant de cotisations sociales sur vos cours",
      system: 0,
      aici: 2,
    },
    {
      label: "Remboursement de 50% instantané",
      system: 0,
      aici: 1,
    },
    {
      label: "Avoir la main sur vos paiements",
      system: 0,
      aici: 1,
    },
    {
      label: "Vous ne gérez ni l'administratif ni la facturation",
      system: 1,
      aici: 1,
    },
  ];

  // Avantages spécifiques pour cette page
  const advantages = [
    {
      ...commonAdvantages[0],
      title: "Réduction des cotisations :",
      description: "Constituez-vous une couverture sociale complète : En plus de gagner davantage que ce que vos élèves paient, vous cotisez à l'URSSAF pour bénéficier d'une couverture sociale incluant la retraite, l'assurance maladie et les allocations familiales."
    },
    ...commonAdvantages.slice(1) // Garde les autres avantages identiques
  ];

  return (
    <AdsPageLayout
      {...config}
      comparisonData={comparisonData}
      advantages={advantages}
      currentSituationImage={schemaPPND}
    />
  );
}
